// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"f36db2ab","526":"1d11eb00","688":"0cce4410","712":"20cbddf5","760":"20c37973"}[chunkId] + ".chunk.css";
};